import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApiMutation } from "../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import { routePaths } from "../../../common/infrastructure/routes/routePaths";
import { DefaultButton } from "../../../common/components/button/defaultButton/DefaultButton";
import styles from "./PaymentResult.module.scss";

export const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const { mutate } = useApiMutation();
  const navigate = useNavigate();
  const cancelledRef = useRef(false);

  const isSuccess = searchParams.get("status") === "success";
  const reservationId = searchParams.get("reservationId");

  useEffect(() => {
    if (cancelledRef.current) return;

    if (!isSuccess && reservationId) {
      cancelledRef.current = true;
      mutate({
        endpoint: `${endpointsMetadata.portalCalendar.cancelStripeReservation}?reservationId=${reservationId}`,
        method: "post",
        disableSuccessToast: true,
        disableErrorToast: true,
      });
    }
  }, [isSuccess, reservationId, mutate]);

  if (isSuccess) {
    return (
      <div className={styles.container}>
        <div className={styles.successAnimation}>
          <div className={styles.successIcon}>
            <span className={styles.checkmark}>✓</span>
          </div>
          <h1 className={styles.successTitle}>Плащането е успешно!</h1>
          <p className={styles.successSubtitle}>
            Вашата фактура е платена. Можете да затворите този прозорец.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.errorAnimation}>
        <div className={styles.errorIcon}>
          <span className={styles.cross}>✕</span>
        </div>
        <h1 className={styles.errorTitle}>Плащането е отказано</h1>
        <p className={styles.errorSubtitle}>
          Резервацията е отменена. Можете да опитате отново по всяко време.
        </p>
        <DefaultButton
          onClick={() => navigate(routePaths.portalAppointment)}
          label="Към началната страница"
          design="accent"
          width="auto"
        />
      </div>
    </div>
  );
};
